import { render, staticRenderFns } from "./headerView.vue?vue&type=template&id=ebda8030&scoped=true&"
import script from "./headerView.vue?vue&type=script&lang=js&"
export * from "./headerView.vue?vue&type=script&lang=js&"
import style0 from "./headerView.vue?vue&type=style&index=0&id=ebda8030&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebda8030",
  null
  
)

export default component.exports